import ApiBase from 'Services/Api/ApiBase';

class Rates extends ApiBase {
    route = '/admin/human-resources/rates';
};

export default new Rates();